"use client";

import { ComponentPropsWithoutRef, useState } from "react";
import Image from "next/image";

interface Props extends ComponentPropsWithoutRef<typeof Image> {
  className: string;
}

export function ImageWithFallback({ className, src, alt, ...rest }: Props) {
  const [failed, setFailed] = useState(false);

  if (!src || failed) {
    return (
      <div className={`flex items-center justify-center ${className}`}>
        <span className="text-sm font-medium text-[#505667] text-center capitalize line-clamp-3">
          {alt}
        </span>
      </div>
    );
  }

  return (
    <Image
      {...rest}
      src={src}
      alt={alt}
      className={className}
      onError={() => setFailed(true)}
    />
  );
}
